import React from 'react';

import styled, { keyframes } from 'styled-components';

const slide = keyframes`
  from {
    transform:translateX(-100%)
  }

  to {
    transform:translateX(100%)
  }
`;

const Badge = styled.div`
  margin-right: 8px;
  padding: 0px 8px;
  background: #4300d2;
  border-radius: 90px;
  color: white;
  text-align: center;
  overflow: hidden;
  position: relative;
  font-size: 12px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    animation: ${slide} 3s infinite;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) 77%,
      rgba(255, 255, 255, 0.3) 92%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

const FloatingBadge = styled(Badge)`
  position: absolute;
  z-index: 1;
  padding: 0px 8px;
  font-size: 10px;
  line-height: 17px;
  margin: 0px;
  left: 30%;
  top: -10px;
`;

const FloaginBadgeContainer = styled.div`
  position: relative;
`;

function ShinyBadge({ title, children = null }) {
  if (children) {
    return (
      <FloaginBadgeContainer className="shiny-badge">
        <FloatingBadge>{title}</FloatingBadge>
        {children}
      </FloaginBadgeContainer>
    );
  }

  return <Badge className="shiny-badge">{title}</Badge>;
}

export default ShinyBadge;
